import { render, staticRenderFns } from "./ReporteCapacitaciones.vue?vue&type=template&id=769f3cc7"
import script from "./ReporteCapacitaciones.vue?vue&type=script&lang=js"
export * from "./ReporteCapacitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports